import { RecurrencyPattern } from './recurrency-pattern';
import { OrderItemTemplate } from './order-item-template';

export class OrderTemplate {
  id: number = 0;
  disabled: boolean = false;
  orderNr: string = '';
  companyID: number;
  orderDate: string;
  customerID: number;
  customerPos: number;
  unloadPointID: number;
  info: string;
  deliveryDateFrom: string;
  deliveryDateTo: string;
  extNr1: string;
  extNr2: string;
  seller: string;
  paymentTermsID: number;
  paymentTermsIDDefault: number;
  paymentTermsDays: number;
  printInfo: string;
  availableHoursFrom: string;
  availableHoursTo: string;
  alertInfo: string;
  orderType: boolean;
  parentID: number;
  assessmentFormID: number;
  assessmentMandatory: boolean;
  ordererCustomerPos: number;
  purchaseOrderNumber: string;
  recurrencyPattern: RecurrencyPattern;
  repeatInterval: number;
  startOccurrence: number;
  endDate: string;
  orderItemTemplates: OrderItemTemplate[] = [];
  customer: any;
  static fromOrder(order) {
    let orderTemplate = new OrderTemplate();
    Object.assign(orderTemplate, {
      id: 0,
      disabled: false,
      orderNr: order.orderNr,
      companyID: order.companyID,
      orderDate: order.orderDate,
      customerID: order.customerID,
      customerPos: order.customerPos,
      unloadPointID: order.unloadPointID,
      info: order.info,
      deliveryDateFrom: order.deliveryDateFrom,
      deliveryDateTo: order.deliveryDateTo,
      extNr1: order.extNr1,
      extNr2: order.extNr2,
      seller: order.seller,
      paymentTermsID: order.paymentTermsID,
      paymentTermsIDDefault: order.paymentTermsIDDefault,
      paymentTermsDays: order.paymentTermsDays,
      printInfo: order.printInfo,
      availableHoursFrom: order.availableHoursFrom,
      availableHoursTo: order.availableHoursTo,
      alertInfo: order.alertInfo,
      orderType: order.orderType,
      parentID: order.parentID,
      assessmentFormID: order.assessmentFormID,
      assessmentMandatory: order.assessmentMandatory,
      ordererCustomerPos: order.ordererCustomerPos,
      purchaseOrderNumber: order.purchaseOrderNumber,
      recurrencyPattern: null,
      orderItemTemplates: Array.isArray(order.orderItems) ? order.orderItems.map(oi => OrderItemTemplate.fromOrderItem(oi)) : [],
      customer: { ...order.customer }
    });
    return orderTemplate;
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/models/order-template.ts